import React, { MouseEventHandler, ReactChild, useState } from "react"
import { LinkParts } from "~/components/atoms/LinkParts";
import { Modal, ModalBody } from "react-bootstrap";
import { HowToButton } from "~/components/molecules/HowToButton";

/**
 簡易版フレーム生成用コンポーネント
 props
 className:クラス名
 **/

interface Props {
  className?: string,
  onChange?: MouseEventHandler,
  onClick?: (params: {}) => void,
  children?: ReactChild | ReactChild[],
  header: {
    key: string
    title: string
    comment: string
    isBasic?: boolean
    url?: string
    tag?: string
    color?: string
  }
}

/**
 基本パック→緑（整備、SSの商品）、黄色（鈑金の商品）
 従業員パック、その他の豊富なオプション、データベース、メンテナンスサービス・初期導入支援→青（業種共通の色）
 オプションの叶えたいことに当たる商品→朱色、空色（叶えたいことが増えると色が増えます）
 * */

export function SimpleAccordion(props: Props) {
  const { children, header, onClick } = props

  const [dialog, dialogState] = useState<boolean>(false)
  const onHide = () => {
    dialogState(false)
  }

  return (
    <>
      <div className="grid-plan grid-versatility-base">
        <div className="grid-area">
          <div className="card">
            <div className={`card-header grid-caption-area ${header.color}`}>
              <div className="caption">{header.title}</div>
              {header.tag && <div className="support-mark">{header.tag}</div>}
              {header.key != "maintenanceSup" && header.key != "edMaintenanceSup" && <div className="pack-explanation">
                <HowToButton />
                {header.url && <LinkParts url="/pack-option.html" className="text-link ml-3" isBlank={true}>パックごとの違いを見る
                  <img src="/pr/assets/svg/icon_link.svg" className="icon" alt="☒" /></LinkParts>}
              </div>
              }
            </div>
            <div>
              <div className={`card-body grid-contents-area ${header.isBasic ? "common" : ""}`}>
                {header.comment && <h3 className="pack-select-title">{header.comment}</h3>}
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal className={"introduction-support-modal"} show={dialog} onHide={onHide}>
        <ModalBody>
          BLからhtmlがくる
        </ModalBody>
      </Modal>
    </>
  )
}

